import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'

import { Navbar, Footer, Hero, Supporters } from 'shared-ui'

import { Logo, OurStory, ThoughtLeadership } from '../../primitives/Icons'

const Layout = ({ children, pageData }) => {
  const mobileCTAS = [
    {
      text: 'Contact Us',
      slug: '/contact/',
    },
  ]
  const navLinksPm = [
    {
      text: 'Overview',
      slug: '/',
    },
    {
      text: 'How it Works',
      slug: '/how-it-works/',
    },
    {
      text: 'Build Your Team',
      slug: '/build-your-team/',
    },
    {
      text: 'Our Talent Pool',
      slug: '/talent/',
    },
    {
      text: 'Partnerning with HR',
      slug: '/partnerships/',
    },
    {
      text: 'About Us',
      dropDownItems: [
        {
          slug: `/about/`,
          head: `Our Story`,
          sub: 'A little bit about us and how we got here.',
          paragraphMax: '220px',
          icon: <OurStory />,
        },
        {
          slug: `/about/philosophy/`,
          head: `Our Philosophy`,
          sub: 'Our take on how we see the workplace evolving.',
          icon: <ThoughtLeadership />,
        },
        // {
        //   slug: `/case-studies/`,
        //   head: `Our Experience`,
        //   sub: 'Lorem ipsum dolor lorem ipsum.',
        //   icon: <OurWork />,
        // },
      ],
    },
  ]

  const siteData = useStaticQuery(graphql`
    query LayoutQuery {
      s1: file(relativePath: { eq: "gSupporter1.png" }) {
        childImageSharp {
          gatsbyImageData(width: 157, layout: FIXED)
        }
      }
      # s2: file(relativePath: { eq: "gSupporter2.png" }) {
      #   childImageSharp {
      #     gatsbyImageData(width: 57, layout: FIXED)
      #   }
      # }
      s3: file(relativePath: { eq: "gSupporter3.png" }) {
        childImageSharp {
          gatsbyImageData(width: 181, layout: FIXED)
        }
      }
      s5: file(relativePath: { eq: "gSupporter5.png" }) {
        childImageSharp {
          gatsbyImageData(width: 100, layout: FIXED)
        }
      }
    }
  `)

  const supporters = [
    siteData.s1.childImageSharp.gatsbyImageData,
    // siteData.s2.childImageSharp.gatsbyImageData,
    siteData.s3.childImageSharp.gatsbyImageData,
    siteData.s5.childImageSharp.gatsbyImageData,
  ]

  // for when a new page is loaded from clicking a DropDown item
  if (typeof document !== `undefined`) {
    document.body.style.overflowX = 'hidden'
  }

  return (
    <>
      <Navbar
        navItems={navLinksPm}
        mobileCTAS={mobileCTAS}
        secondaryLogo={{ icon: <Logo />, head: 'Workforce' }}
      />
      <main>
        {!!pageData.hero && (
          <Hero
            {...pageData.hero}
            slug={
              !pageData.hero.noSlug ? pageData.hero.slug || '/contact/' : ``
            }
          />
        )}
        {!pageData.noSupporters && (
          <Supporters pad={'1rem'} logos={supporters} headless maxW={1600} />
        )}
        {children}
      </main>
      <Footer {...pageData.footer} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
